import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  menuFormList: [],
  loading: false,
  error: undefined,
};

const menuSlice = createSlice({
  name: "menu",
  initialState,
  reducers: {
    clearError(state) {
      state.error = undefined;
    },
    actionStart(state) {
      state.loading = true;
      state.error = undefined;
    },
    fetchMenuFormList(state, action) {
      state.menuFormList = action.payload;
      state.loading = false;
    },
  },
});

export const menuActions = menuSlice.actions;

export default menuSlice.reducer;
